import { useCallback, useEffect } from 'react';
import { useGetTasteProfileForUserLazyQuery } from 'src/gqlReactTypings.generated.d';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useTasteProfileStoreSelectors } from '../taste-profile-store';

export const useTasteProfileForUser = () => {
  const [fetchTasteProfileForUser] = useGetTasteProfileForUserLazyQuery();
  const [currentUser] = useCurrentUser();
  const setTasteProfile = useTasteProfileStoreSelectors.use.setTasteProfile();
  const tasteProfile = useTasteProfileStoreSelectors.use.tasteProfile?.();
  const loaded = useTasteProfileStoreSelectors.use.loaded();
  const setLoading = useTasteProfileStoreSelectors.use.setLoading();
  const setLoaded = useTasteProfileStoreSelectors.use.setLoaded();

  // Private shared function to fetch the taste profile for the current user
  const fetch = useCallback(async () => {
    setLoading(true);
    setLoaded(false);

    const { data } = await fetchTasteProfileForUser();
    const tasteProfileForUser = data?.getTasteProfileForUser;

    setTasteProfile(tasteProfileForUser ?? undefined);
    setLoaded(true);
    setLoading(false);
  }, [fetchTasteProfileForUser, setLoading, setLoaded, setTasteProfile]);

  const refetchTasteProfile = useCallback(async () => {
    if (!currentUser?.id) return;
    await fetch().catch(() => setLoading(false));
  }, [currentUser?.id, fetch, setLoading]);

  useEffect(() => {
    if (!currentUser?.id || tasteProfile || loaded) {
      return;
    }

    fetch().catch(() => setLoading(false));
  }, [currentUser?.id, tasteProfile, loaded, setLoading, fetch]);

  return {
    tasteProfile: useTasteProfileStoreSelectors.use.tasteProfile?.(),
    refetchTasteProfile,
  };
};
